import 'arrayq';

import { PureConnect, React } from '../../react';
import { notesEditor } from './resource';
import cx from './style.less';
import { INote, IQuestionDB, isQuestion } from '../../types';
import { Btn } from '../../react-toolbox-redesign/button';
import NOTE_DELETE_WITH_CHAT from './actions/NOTE_DELETE_WITH_CHAT';
import { questionsEditor, questionsResource } from '../question/resource';

export const NoteDeleteArea =  PureConnect('NoteDeleteArea')(
    (state) => ({
        deleting: notesEditor.selectors.deleting(state),
        item: notesEditor.selectors.item(state),
        allQuestions: questionsResource.selectors.items(state),
    }),
    (dispatch) => ({}),
    ({ deleting, item, allQuestions }) => {
                      
        const isquestion = isQuestion(item);

        return (           
                <div className={cx(!(deleting) ? 'wcag-invisible' : '', 'warning')}  aria-hidden={!(deleting)} aria-labelledby={isquestion? 'Verwijder vraag': 'Verwijder notitie'}>
                    <div className={cx('warning-container')}>
                        <div className={cx('warning-title')}>{isquestion? 'Vraag': 'Notitie'} verwijderen</div>
                        <div className={cx('warning-content')}>
                            <p>
                                U staat op het punt een {isquestion? 'vraag': 'notitie'} te verwijderen. 
                                {isquestion? '': 'Als de notitie is gedeeld met personen en/of groepen zal deze ook verdwijnen uit hun archief.'}
                            </p>
                            <p className={cx('medium')}>
                                Deze actie kunt u niet ongedaan maken.
                            </p>
                        </div>
                    </div>
                </div>          
        );
    });

export default NoteDeleteArea;

export const NoteDeleteAreaSave =  PureConnect('NoteDeleteAreaSave')(
        (state) => ({
            deleting: notesEditor.selectors.deleting(state),
            item: notesEditor.selectors.item(state),
            allQuestions: questionsResource.selectors.items(state),
            origin: state.notemenu.origin,
        }),
        (dispatch) => ({
            cancelDelete: (item: INote, allQuestions: IQuestionDB[]) => {
                dispatch(notesEditor.actions.DELETE_CANCEL({item}));
                dispatch(notesEditor.actions.READ({item}));
                var readquestion = false;
                if (isQuestion(item)) {                            
                    var current = allQuestions.qWhere((x) => x.noteId === item.id).qFirst();
                    if (current) {            
                        dispatch(questionsEditor.actions.READ({ item: current })); 
                        readquestion = true; 
                    }
                }    
                if (isQuestion(item) && !readquestion) {
                    dispatch(questionsEditor.actions.READ_CANCEL({}));
                }                            
            },
            // saveDelete: (item: INote) => dispatch(notesEditor.actions.DELETE_CONTINUE({ item })),
            saveDelete: (item: INote) => dispatch(NOTE_DELETE_WITH_CHAT({ item })),
        }),
        ({ deleting, item, allQuestions, cancelDelete, saveDelete }) => {
            return (           
                    <div className={cx(!(deleting) ? 'wcag-invisible' : '', 'fields-container')}  aria-hidden={!(deleting)} aria-labelledby= "Verwijder notitie">
                        <div className={cx('bottom-buttons-container', 'not-absolute')}>
                            <div className={cx('buttons-container', !(deleting)? 'wcag-invisible' : '' )}>                            
                                <Btn 
                                    type="button" 
                                    className={'btn'} 
                                    extraClassNames={'secondary-btn'}
                                    aria-label={'Annuleren'}
                                    aria-haspopup={false}                        
                                    tabIndex={0} 
                                    onKeyDown={(evt: any) => cancelDelete(item, allQuestions)}                           
                                    onClick={(evt: any) => cancelDelete(item, allQuestions)}                                                                                             
                                    >
                                        <span>Annuleren</span>
                                </Btn>
        
                                <Btn 
                                    type="button" 
                                    className={'btn'} 
                                    aria-label={'Verwijderen'}
                                    aria-haspopup={false}                        
                                    tabIndex={item.text ? 0 : -1} 
                                    disabled={!item.text} 
                                    onKeyDown={(evt: any) => saveDelete(item)}                           
                                    onClick={(evt: any) => saveDelete(item)}                                                                                       
                                    >
                                        <span>Verwijderen</span>
                                </Btn>                 
                            </div>
                        </div>
                    </div>          
            );
        });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notes/noteDeleteArea.tsx